export const sanitizeInput = (value, type) => {
    switch (type) {
        case 'numeric':
            return value.replace(/[^\d]/g, ''); // only numbers
        case 'alphanumeric':
            return value.replace(/[^a-zA-ZÀ-ÿ0-9ñÑüÜ ]/g, ''); // letters (incl. accents), numbers, spaces
        case 'text':
            return value.replace(/[^a-zA-ZÀ-ÿñÑüÜ ]/g, ''); // only letters (incl. accents), spaces
        default:
            return value;
    }
};
